export default __webpack_public_path__ + "static/media/signup-community-msg.d8d0cb77.svg";